import { requestJson } from "@/lib/api";

/** Feature flags de módulo que o backend expõe no bootstrap (fonte de verdade). */
export interface ModuleFlags {
  supplierNfEnabled: boolean;
}

/**
 * Lê os flags de módulo do bootstrap do backend. Coerção estrita para booleano: qualquer coisa que não
 * seja exatamente `true` (ausente, null, undefined) vira `false` — fail-safe = módulo escondido até o
 * backend afirmar que está ligado.
 */
export async function fetchModuleFlags(): Promise<ModuleFlags> {
  const resp = await requestJson<{ supplierNfEnabled?: boolean }>("/api/v1/bootstrap");
  return { supplierNfEnabled: resp.supplierNfEnabled === true };
}
